import React, { useState, useEffect } from 'react';
import MmcTabSystem from './core/mmc_tab_system';
import MmcModuleRegistry from './core/mmc_module_registry';
import { autodiscovered_modules } from './modules';
import './styles/mmc-reset.css';
import './App.css';

function App() {
  const [registry] = useState(new MmcModuleRegistry());
  const [modules, set_modules] = useState([]);

  useEffect(() => {
    // Autodiscover and Register all modules
    autodiscovered_modules.forEach(({ manifest, component }) => {
      if (component) {
        registry.register_module(manifest, component);
        console.log(`[Autodiscover] Registered: ${manifest.id}`);
      }
    });

    // Prepare modules for the tab system
    const loaded_modules = autodiscovered_modules
      .filter(m => !!m.component)
      .map(m => ({ ...m.manifest, component: m.component }))
      .sort((a, b) => (a.order || 999) - (b.order || 999));

    set_modules(loaded_modules);
  }, [registry]);

  return (
    <div className="app">
      <MmcTabSystem modules={modules} registry={registry} />
    </div>
  );
}

export default App;